;(function($){
  /**
   * 葉
   * 
   * @param {object} $container 
   */
  function Leaf($container) {
    var props = {
      $viewport: $container,
      stacked: 0,
      width: null,
      height: null,
      leaves: [],
      numLeaves: 6,
      leafTypes: 12,
      xBoost: 0.12,
      yBoost: 0.2,
      rotationBoost: 0.2,
      wind: {
        force: 1.2,
        minSpeed: 2,
        maxSpeed: 10,
        duration: 300,
        start: 0
      },
      timer: 0
    };

    /**
     * リサイズ時にエリアをフィット
     */
    function bindResize() {
      var handleResize = function() {
        props.width = props.$viewport.innerWidth();
        props.height = props.$viewport.innerHeight();
      }
      
      handleResize();
      $(window).on('resize', handleResize);
    }

    /**
     * 初期化
     */
    function init() {
      for (var i = 0; i < props.numLeaves; i++) {
        var leaf = {
          $elm: $('<div>'),
          x: 0,
          y: 0,
          rotation: {
            value: 0,
            speed: 0
          },
          type: 0,
          xSpeedVariation: 0,
          ySpeed: 0,
          rotateVariation: 0
        };

        leaf = resetLeaf(leaf);
        leaf.$elm.addClass('falling_leaf');
        props.$viewport.append(leaf.$elm);
        props.leaves.push(leaf);
      }
    };

    /**
     * レンダリング
     */
    function render() {
      updateWind();
      for (var i = 0; i < props.leaves.length; i++) {
        updateLeaf(props.leaves[i]);
      }

      props.timer++;

      requestAnimationFrame(render);
    }

    /**
     * 葉の情報をリセット
     * 
     * @param {object} leaf 
     * @return {object} leaf
     */
    function resetLeaf(leaf) {
      leaf.x = random(-100, -0.6 * props.width);
      leaf.y = random(-500, 0.5 * props.height);

      leaf.xSpeedVariation = random(5, 8);
      leaf.ySpeed = random(1, 3);

      leaf.rotation.speed = random(-0.1, 0.4);
      leaf.rotateVariation = random(0.2, 0.4);

      if (leaf.rotation.speed > -0.1 && leaf.rotation.speed < 0) {
        leaf.rotation.speed = -0.1;
      }
      if (leaf.rotation.speed < 0.1 && leaf.rotation.speed > 0) {
        leaf.rotation.speed = 0.1;
      }

      leaf.type = Math.floor(random(0, props.leafTypes));
      leaf.$elm.attr('data-num', leaf.type);

      // XY軸の回転
      TweenMax.to(leaf.$elm, random(4, 6), {
        rotationX: random(10, 30),
        rotationY: random(10, 30),
        repeat: -1,
        yoyo: true,
        ease: Sine.easeInOut,
        delay: -5
      });

      return leaf;
    }

    /**
     * 葉の位置を更新
     *
     * @param {object} leaf
     */
    function updateLeaf(leaf) {
      var calcedSpeed = getSpeed(props.timer - props.wind.start, leaf.y);
      var xSpeed      = calcedSpeed.speed + leaf.xSpeedVariation;
      var addRotation = 2 * calcedSpeed.percent;
      var accel = 1;

      if (leaf.type > props.leafTypes * 0.7) {
        accel = 2;
      } else if (leaf.type > props.leafTypes * 0.3) {
        accel = 1.5;
      }
  
      leaf.x += (xSpeed * accel) * props.xBoost;
      leaf.y += (leaf.ySpeed) * props.yBoost;
      leaf.rotation.value += (leaf.rotation.speed + leaf.rotateVariation + addRotation) * props.rotationBoost;

      TweenMax.set(leaf.$elm, {
        x: leaf.x,
        y: leaf.y,
        rotationZ: leaf.rotation.value
      });

      leaf.rotation.value += leaf.rotation.speed;

      if (leaf.x > props.width + 100 || leaf.y > props.height + 100) {
        resetLeaf(leaf);
      }
    }

    /**
     * スピードの算出
     */
    function getSpeed(t, y) {
      var a     = 0.5 * props.wind.force * (props.height - y / 2) / props.height;
      var speed = a * Math.sin( 2 * Math.PI * t / props.wind.duration + (3 * Math.PI / 2)) + a
      return {
        speed: speed,
        percent: speed / (2 * a)
      };
    }

    /**
     * 風を変える
     *
     * 風が強い時ほど持続時間を長くする
     */
    function updateWind() {
      if (props.timer === 0 || props.timer > (props.wind.start + props.wind.duration)) {
        props.wind.force    = random(props.wind.minSpeed, props.wind.maxSpeed);
        props.wind.duration = props.wind.force * 50 + random(-10, 10);
        props.wind.start    = props.timer;
      }
    }

    /**
     * 指定した範囲の乱数生成
     * 
     * @param {number} min
     * @param {number} max
     * @return {number} min-maxの間の乱数
     */
    function random(min, max) {
      return min + Math.random() * (max - min);
    }

    /**
     * 移動開始
     */
    this.run = function() {
      bindResize();
      init();
      render();
    };
  }

  window.Leaf = Leaf;
})(jQuery);